export default "__VITE_ASSET__Byfzwvgs__"